import { DataGrid, GridPagination } from "@mui/x-data-grid";
import React, { useContext, useEffect, useState } from "react";
// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import {
  Box,
  Chip,
  CircularProgress,
  Icon,
  LinearProgress,
  Stack,
} from "@mui/material";
import MaterialBox from "../MaterialBox";
import MaterialInput from "../MaterialInput";
import SearchIcon from "@mui/icons-material/Search";
import CustomizedPagination from "./components/CustomPagination";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import MaterialTypography from "../MaterialTypography";
import { Info } from "@mui/icons-material";
import Grid from "@mui/material/Grid2";


// import { motion } from "framer-motion";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DesignationContext } from "../../context/designationcontext";
import { useLocation } from "react-router-dom";
function CustomPagination(props) {
  return <GridPagination ActionsComponent={CustomizedPagination} {...props} />;
}

const MaterialDataGrid = ({
  rows,
  columns,
  checkboxSelection,
  onRowClick,
  customHeight,
  loading,
  localeText,
  isSelectable,
  noSearch,
  noPagination,
  subTab
}) => {
  const [searchText, setSearchText] = useState("");
  const [searchResults, setSearchResults] = useState([]);

     const location = useLocation()

     const[isfilterneeded,setisfilter] = useState(false)

     const pathtofilter = [

     "/permission",
     "/regularization-request",
     "/wfh-management",
     "/leave-management",

     ]

     useEffect(()=>{
      
      for(let val of pathtofilter){
         if(val==location.pathname){
          setisfilter(true)
         }
      }

     },[location])
 
  const [hasSearched, setHasSearched] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // const [selectedValue, setSelectedValue] = useState(""); // State to store selected value
  // const[filteredresults,setFilteredresults] = useState([])
  // const[columnvalue,setcolumnvalue] = useState('')

  const{

    selectedValue, setSelectedValue,
              filteredresults,setFilteredresults,columnvalue,setcolumnvalue,handleClearSelection,rowdata,setrowdata

  }  = useContext(DesignationContext)

  
   
  const[uniquevalue,setuniquevalue] = useState([])

  const handleArrowClick = () => {
   
    document.getElementById("demo-simple-select").focus();
  };

  //  handleClearSelection = () => {


  //   setSelectedValue("");
  //   setcolumnvalue("")
  //   setFilteredresults(rowdata)
  // };

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
 
      setuniquevalue([...new Set(rows?.map(item=>item[event.target.value]))])


  };
  const handleuniquechange =(event)=>{
    setcolumnvalue(event.target.value)

     const finalrow = rows?.filter((row)=>row[selectedValue]==event.target.value)
     setFilteredresults(finalrow)
  }
  

  useEffect(() => {
    if (searchText && searchText.length > 1) {
      const timeoutId = setTimeout(() => {
        getSearchDetails(searchText);
      }, 300); // Debounce search
      return () => clearTimeout(timeoutId);
    } else {
      setSearchResults([]); // Reset to all rows if searchText is cleared
    }
  }, [searchText, rows]);
 
  const scrolltoId = (id) => {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView();
  };
 
  const getSearchDetails = async (searchText) => {
    setSearchResults([]);
    setIsLoading(true);
    scrolltoId("search");
 
    if (!hasSearched) setHasSearched(true);
 
    // Filter rows based on searchText
    const results = rows.filter((row) => {
      // Ensure row and its fields are defined before calling .toString()
      return Object.values(row).some((value) =>
        value?.toString().toLowerCase().includes(searchText.toLowerCase())
      );
    });
 
    setSearchResults(results);
    setIsLoading(false);
  };

  // const columnsData = columns.map((column) => {
  //     return ({
  //         field: column.field,
  //         headerName: <MaterialTypography variant="caption" color="black" fontWeight='mediumn'
  //             sx={({ typography: { size } }) => ({
  //                 fontSize: size.sm
  //             })}
  //         >
  //             {column.headerName}
  //         </MaterialTypography>,
  //         flex: column.flex,
  //         width: column.width,
  //         // disableColumnMenu: true,
  //         sortable: true,
  //         renderCell: (params) => (
  //             column.type === "status" ?
  //                 <Stack direction="row" alignItems="center" textAlign='center' gap={1} mt={1.5}>
  //                     <Chip label={params.row.status?.label}
  //                         size="small"
  //                         icon={params.row.status?.icon || <Info />}
  //                         color={params.row.status?.color}
  //                     />
  //                 </Stack>
  //                 :
  //                 column.type === "images" ?
  //                     <>
  //                         <img className='image' src={params.row.image} />
  //                     </>
  //                     :
  //                     <MaterialTypography variant="caption" color="dark"
  //                         sx={({ typography: { size } }) => ({
  //                             fontSize: size.sm
  //                         })}
  //                     >
  //                         {params.row[column.field]}
  //                     </MaterialTypography>
  //         )
  //     })
  // })
   

  const columnsData = columns.map((column) => ({
    field: column.field,
    headerName:
      typeof column.headerName === "string" ? column.headerName : column.field,
    renderHeader:
      column.headerName && typeof column.headerName === "string"
        ? () => (
            <MaterialTypography
              variant="caption"
              color="black"
              fontWeight="medium"
              sx={({ typography: { size } }) => ({ fontSize: size.sm })}
            >
              {column.headerName}
            </MaterialTypography>
          )
        : undefined,
    flex: column.flex,
    width: column.width,
    sortable: true,
    renderCell: (params) =>
      column.type === "status" ? (
        <Stack
          direction="row"
          alignItems="center"
          textAlign="center"
          gap={1}
          mt={1.5}
        >
          <Chip
            label={params.row.status?.label}
            size="small"
            icon={params.row.status?.icon || <Info />}
            color={params.row.status?.color}
          />
        </Stack>
      ) : column.type === "images" ? (
        <img className="image" src={params.row.image} alt="column image" />
      ) : (
        <MaterialTypography
          variant="caption"
          color="dark"
          sx={({ typography: { size } }) => ({ fontSize: size.sm })}
        >
          {params.row[column.field]}
        </MaterialTypography>
      ),
  }));

  return (
    <MaterialBox>
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        spacing={2}
        p={1}
      >
        <Grid item xs={12} sm={9}>
          {subTab && <MaterialBox>{subTab}</MaterialBox>}
        </Grid>
       
    

       

        <Grid item xs={12} sm={3}>
          <MaterialBox display="flex" justifyContent="flex-end" width="100%">
            {!noSearch && (
              <MaterialInput
                label="Search"
                placeholder="Search..."
                fullWidth
                variant="outlined"
                size="medium"
                value={searchText}
                inputProps={{
                  maxlength: "15",
                }}
                onChange={(e) => setSearchText(e.target.value)}
                icon={
                  isLoading
                    ? {
                        direction: "right",
                        component: (
                          <CircularProgress color="success" size={18} />
                        ),
                      }
                    : {
                        direction: "right",
                        component: (
                          <Icon color="action" fontSize="small">
                            <SearchIcon />
                          </Icon>
                        ),
                      }
                }
              />
            )}
          </MaterialBox>
        </Grid>
      </Grid>

      <Box style={{ height: customHeight ? customHeight : 400, width: "100%" }}>
        <DataGrid
          // rows={searchResults?.length>0?searchResults:filteredresults?.length>0?filteredresults:rows}
          // rows={filteredresults?.length > 0 ? filteredresults:rows}
          rows={searchResults && searchResults.length > 0 ? searchResults 
            : filteredresults && filteredresults.length > 0 ? filteredresults 
            : rows}
          columns={columnsData}
          style={{
            border: 0,
            cursor: onRowClick && "pointer",
          }}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10,
              },
            },
          }}
          slots={{
            // pagination: CustomPagination,
            loadingOverlay: (props) => (
              <MaterialBox style={{ overflow: "hidden" }}>
                <LinearProgress color="dark" {...props} />
              </MaterialBox>
            ),
          }}
          loading={loading}
          checkboxSelection={checkboxSelection}
          disableRowSelectionOnClick
          // rowSelectionModel={false}
          rowsPerPageOptions={[25, 50, 100]}
          onRowClick={onRowClick}
          isSelectable={isSelectable}
          // getRowHeight={() => 'auto'}
          density="standard"
          // disableColumnMenu
          sx={{
            "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
              width: "1px",
              height: "1px",
            },
            "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track": {
              borderRadius: "5px",
            },
            "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb": {
              backgroundColor: "grey.400",
              borderRadius: "10px",
            },
            //if isSelectable is true
            ...(!isSelectable && {
              "&  .MuiDataGrid-cell": {
                //focus color
                "&:focus": {
                  outline: "none",
                },
              },
            }),
          }}
          disableSelectionOnClick
          disablePagination
          localeText={localeText}
        />
      </Box>
    
    </MaterialBox>
  );
};

// Typechecking props for the MaterialDataGrid
MaterialDataGrid.propTypes = {
  rows: PropTypes.number,
  columns: PropTypes.number,
  checkboxSelection: PropTypes.bool,
  isSelectable: PropTypes.bool,
  loading: PropTypes.bool,
  isSelectable: PropTypes.bool,
  onRowClick: PropTypes.func,
  localeText: PropTypes.object,
};

export default MaterialDataGrid;
